<template>
  <div>
    <TagsList v-if="project"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TagsList from '@/components/coding-admin/tags-list.vue';
export default {
  name: 'ProjectTags',
  components: {TagsList},
  data: function() {
    return {
    }
  },

  mounted() {
    const projectUid = this.$route.params.project_uid;
    this.$emit('setHeaderPrimaryName', this.project.project_name);
    //this.$emit('setHeaderSecondaryName', 'Tags List');
  },

  computed: {
       ...mapState({
        user: state => state.user.user.data,
        project: state => state.projects.project.data
      }),
  },
};
</script>